import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useEventListener } from '@beef/react';
import { Card, CloseIcon } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { SwiperSlide } from 'swiper/react';
import { CarouselWithNavigation } from "../../Carousel/components/CarouselWithNavigation";
import { isSwiperContainer } from "../utils";
import { STORY_MOBILE_HEIGHT } from "../../../constants/common";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { useMobileWindowHeight } from "../../../hooks/useMobileWindowHeight";
import baseStyle from "../../../styles/base.module.pcss";
import { StoryDetail } from "./index";
import style from "./styles.module.pcss";
var cn = classNames.bind(_objectSpread(_objectSpread({}, style), baseStyle));
var SLIDER_SETTINGS = {
  breakpoints: {
    320: {
      spaceBetween: 12
    },
    767: {
      spaceBetween: 24
    },
    1024: {
      spaceBetween: 24
    },
    1280: {
      spaceBetween: 24
    }
  },
  centeredSlides: true,
  navigation: false,
  observeParents: true,
  observer: true,
  simulateTouch: false,
  spaceBetween: 0
};
var StorySlideList = function StorySlideList(_ref) {
  var detailSliderSettings = _ref.detailSliderSettings,
    handleStoryViewed = _ref.handleStoryViewed,
    _ref$initialSlide = _ref.initialSlide,
    initialSlide = _ref$initialSlide === void 0 ? 0 : _ref$initialSlide,
    onClose = _ref.onClose,
    _onDetailClick = _ref.onDetailClick,
    onTimeoutLast = _ref.onTimeoutLast,
    _ref$stories = _ref.stories,
    stories = _ref$stories === void 0 ? [] : _ref$stories;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    swiper = _useState2[0],
    setSwiper = _useState2[1];
  var _useState3 = useState(initialSlide),
    _useState4 = _slicedToArray(_useState3, 2),
    activeIndex = _useState4[0],
    setActiveIndex = _useState4[1];
  var isSlideInTransition = useRef(false);
  var isMobile = useIsMobile();
  var slideTo = useCallback(function (index) {
    handleStoryViewed === null || handleStoryViewed === void 0 ? void 0 : handleStoryViewed(index);
    setActiveIndex(index);
  }, [handleStoryViewed]);
  useLayoutEffect(function () {
    if (swiper !== null && swiper !== void 0 && swiper.slideTo) {
      swiper.slideTo(activeIndex);
      swiper.update();
    }
  }, [activeIndex, swiper]);
  useEffect(function () {
    if (handleStoryViewed) {
      handleStoryViewed(activeIndex);
    }
  }, [activeIndex, handleStoryViewed]);
  useEventListener('click', function (event) {
    if (event.target && isSwiperContainer(event.target)) {
      onClose === null || onClose === void 0 ? void 0 : onClose();
    }
  });
  var commonStoryRef = useMobileWindowHeight(STORY_MOBILE_HEIGHT);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('list-wrap'),
    ref: commonStoryRef,
    "data-t-id": "StoriesV2-StoryDetail"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('close-btn-wrap')
  }, /*#__PURE__*/React.createElement("button", {
    className: cn('close-btn'),
    onClick: onClose,
    type: "button"
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("div", {
    className: cn('carousel-wrap', {
      fix_carousel_desktop: !isMobile
    })
  }, /*#__PURE__*/React.createElement(CarouselWithNavigation, {
    btnClassname: cn('slider-btn'),
    customChildren: true,
    nextBtnClassname: cn('slider-btn--next'),
    paginatePadding: false,
    prevBtnClassname: cn('slider-btn--prev'),
    settings: _objectSpread(_objectSpread({}, SLIDER_SETTINGS), {}, {
      centeredSlides: true,
      onSlideChange: function onSlideChange(swiperInstance) {
        /**
         * @desc: Для корректной центровки сториса требуется учитывать индекс активной карточки начиная с 0.
         * Обновление вызывает swiper.update() в useLayoutEffect при смене activeIndex, выше по коду.
         */
        if (swiperInstance.activeIndex >= 0) {
          setActiveIndex(swiperInstance.activeIndex);
        }
      },
      onSwiper: function onSwiper(swiperInstance) {
        setSwiper(swiperInstance);
      },
      onTouchEnd: function onTouchEnd(swiperInstance) {
        var isBeginning = swiperInstance.isBeginning,
          isEnd = swiperInstance.isEnd,
          diff = swiperInstance.touches.diff;
        if (diff > 0 && isBeginning || diff < 0 && isEnd) {
          onClose === null || onClose === void 0 ? void 0 : onClose();
        }
      },
      slidesPerView: 'auto',
      onSlideChangeTransitionEnd: function onSlideChangeTransitionEnd() {
        isSlideInTransition.current = false;
      },
      onSlideChangeTransitionStart: function onSlideChangeTransitionStart() {
        isSlideInTransition.current = true;
      }
    }, detailSliderSettings),
    verticalCentered: true
  }, stories.map(function (story, i) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      key: +i
    }, function (_ref2) {
      var isActive = _ref2.isActive;
      return /*#__PURE__*/React.createElement("div", {
        className: cn('slide-wrap')
      }, /*#__PURE__*/React.createElement(Card, {
        bordered: false,
        className: cn('slide-card')
      }, /*#__PURE__*/React.createElement("div", {
        className: cn('list-item', {
          'list-item--active': isActive
        }),
        "data-t-id": "StoriesV2-StoryDetail"
      }, /*#__PURE__*/React.createElement(StoryDetail, {
        active: isActive,
        isSlideInTransition: isSlideInTransition,
        key: story.id,
        onDetailClick: function onDetailClick(e, detailData) {
          if (_onDetailClick) {
            _onDetailClick(e, _objectSpread(_objectSpread({}, detailData), {}, {
              index: i,
              id: story.id
            }));
          }
        },
        onLeftSlide: function onLeftSlide() {
          if (activeIndex === 0) return;
          slideTo(activeIndex - 1);
        },
        onRightSlide: function onRightSlide() {
          if (i + 1 === stories.length) {
            if (onTimeoutLast) {
              onTimeoutLast();
            }
          } else {
            slideTo(i + 1);
          }
        },
        story: story
      }), !isActive && /*#__PURE__*/React.createElement("button", {
        className: cn('list-item__btn'),
        onClick: function onClick() {
          slideTo(i);
        },
        type: "button"
      }, /*#__PURE__*/React.createElement("div", {
        className: cn('sr-only')
      }, "\u0441\u043B\u0430\u0439\u0434 ", story.text)))));
    });
  }))));
};
export { StorySlideList };